import * as Models from "../models/models";
import { AxiosInstance, AxiosResponse } from "axios";

export class Apis {
  private instance: AxiosInstance;
  constructor(i: AxiosInstance) {
    this.instance = i;
  }
  // Input Elements
  GetAllInputElements = async () => {
    const { data }: AxiosResponse<Models.InputElement[]> = await this.instance.get(`/InputElements`);
    return data;
  };
  GetAllInputElementById = async (id: string) => {
    const { data }: AxiosResponse<Models.InputElement> = await this.instance.get(`/InputElements/${id}`);
    return data;
  };
  AddInputElements = async (inputElement: Models.InputElement) => {
    const { data }: AxiosResponse<Models.InputElement> = await this.instance.post(`/InputElements`, inputElement);
    return data;
  };
  UpdateInputElements = async (id: string, inputElement: Models.InputElement) => {
    const { data }: AxiosResponse<Models.InputElement> = await this.instance.put(`/InputElements/${id}`, inputElement);
    return data;
  };
  DeleteInputElements = async (id: string) => {
    const { data }: AxiosResponse<Models.InputElement> = await this.instance.delete(`/InputElements/${id}`);
    return data;
  };

  UpdateSortOrder = async (id: number, type: string, order: number[]) => {
    const { data }: AxiosResponse<Models.Module> = await this.instance.put(`/Modules/SortOrder/${id}/${type}`, order);
    return data;
  };

  UpdateModulesSortOrder = async (order: number[]) => {
    const { data }: AxiosResponse<Models.Module[]> = await this.instance.post(`/Modules/SortOrder`, order);
    return data;
  };
  // Modules
  GetAllModules = async () => {
    const { data }: AxiosResponse<Models.Module[]> = await this.instance.get(`/Modules`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  };
  GetAllModuleById = async (id: string) => {
    const { data }: AxiosResponse<Models.Module> = await this.instance.get(`/Modules/${id}`);
    return data;
  };
  AddModule = async (module: Models.Module) => {
    const { data }: AxiosResponse<{ module: Models.Module; inputs: Models.InputElement[] }> = await this.instance.post(`/Modules`, module);
    return data;
  };
  UpdateModule = async (id: string, module: Models.Module) => {
    const { data }: AxiosResponse<Models.Module> = await this.instance.put(`/Modules/${id}`, module);
    return data;
  };
  DeleteModule = async (id: string) => {
    const { data }: AxiosResponse<Models.Module> = await this.instance.delete(`/Modules/${id}`);
    return data;
  };

  UpdateModuleAssumptions = async (id: number, assumptions: string) => {
    const { data }: AxiosResponse<Models.Module> = await this.instance.put(`/Modules/Assumptions/${id}`, assumptions, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return data;
  };

  // Formula Elements
  GetAllFormulas = async () => {
    const { data }: AxiosResponse<Models.FormulaElement[]> = await this.instance.get(`/FormulaElements`);
    return data;
  };
  GetAllFormulaById = async (id: string) => {
    const { data }: AxiosResponse<Models.FormulaElement> = await this.instance.get(`/FormulaElements/${id}`);
    return data;
  };
  AddFormula = async (formula: Models.FormulaElement) => {
    const { data }: AxiosResponse<Models.FormulaElement> = await this.instance.post(`/FormulaElements`, formula);
    return data;
  };
  UpdateFormula = async (id: string, formula: Models.FormulaElement) => {
    const { data }: AxiosResponse<Models.FormulaElement> = await this.instance.put(`/FormulaElements/${id}`, formula);
    return data;
  };
  DeleteFormula = async (id: string) => {
    const { data }: AxiosResponse<Models.FormulaElement> = await this.instance.delete(`/FormulaElements/${id}`);
    return data;
  };
  EvaluateFormulas = async (selectedInputs: { [key: string]: string | number | null }, id: string) => {
    const ds: { [key: string]: string } = JSON.parse(JSON.stringify(selectedInputs));
    const p: { [key: string]: string } = {};
    Object.keys(ds).map((d) => {
      p[d] = ds[d].toString();
    });
    const { data }: AxiosResponse<Models.FormulaResult> = await this.instance.post(`/FormulaEvaluation/${id}`, p);
    return data;
  };

  GetReportInputElementsBasedOnReportId = async (reportId: string) => {
    const { data }: AxiosResponse<Record<string, string>> = await this.instance.post(`/FormulaEvaluation/InputElements/${reportId}`, {
      headers: { "Content-Type": "application/json" },
    });
    return data;
  };

  // Lookup Data
  GetAllPageNo = async () => {
    const { data }: AxiosResponse<{ [year: string]: string[] }> = await this.instance.get(`/LookupData/AllPageNo`);
    return data;
  };

  GetLookupDataByPageNo = async (pageNo: string, year: string) => {
    const { data }: AxiosResponse<Models.LookupData[]> = await this.instance.get(`/LookupData/${pageNo}/${year}`);
    return data;
  };

  UploadLookupData = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data }: AxiosResponse<string> = await this.instance.post(`/Lookupdata/UploadData`, formData);
    return data;
  };

  DeleteLookupData = async () => {
    const { data }: AxiosResponse<string> = await this.instance.delete(`/Lookupdata/DeleteAll`);
    return data;
  };

  // ExportImport Module Data

  ImportModule = async (name: string, parentId: number, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data }: AxiosResponse<{ formulaElements: Models.FormulaElement[]; inputElements: Models.InputElement[]; moduleData: Models.Module }> =
      await this.instance.post(`/ImportExport/Import/${name}/${parentId}`, formData);
    return data;
  };
  ExportModule = async (id: number) => {
    const { data }: AxiosResponse<{ FormulaElements: Models.FormulaElement[]; InputElements: Models.InputElement[]; ModuleData: Models.Module }> =
      await this.instance.post(`/ImportExport/Export/${id}`);
    return data;
  };

  UploadLogo = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const { data }: AxiosResponse<string> = await this.instance.post(`/ImportExport/UploadLogo`, formData);
    return data;
  };

  GetInsuranceCodeTypes = async () => {
    const { data }: AxiosResponse<Models.InsuranceCodeType[]> = await this.instance.get(`/InsuranceCodeTypes`);
    return data;
  };
  AddInsuranceCodeType = async (codeType: string, percentage: string) => {
    const { data }: AxiosResponse<Models.InsuranceCodeType> = await this.instance.post(`/InsuranceCodeTypes`, { codeType, percentage });
    return data;
  };
  UpdateInsuranceCodeType = async (id: number, codeType: string, percentage: string) => {
    const { data }: AxiosResponse<Models.InsuranceCodeType> = await this.instance.put(`/InsuranceCodeTypes/${id}`, { codeType, percentage });
    return data;
  };
  DeleteInsuranceCodeType = async (id: number) => {
    const { data }: AxiosResponse<Models.InsuranceCodeType> = await this.instance.delete(`/InsuranceCodeTypes/${id}`);
    return data;
  };
  BulkDeleteInsuranceCodeTypes = async (ids: number[]) => {
    const { data }: AxiosResponse<Models.InsuranceCodeType[]> = await this.instance.delete(`/InsuranceCodeTypes/bulk`, { data: ids });
    return data;
  };
  BulkUploadInsuranceCodeTypes = async (items: { codeType: string; percentage: string }[]) => {
    const { data }: AxiosResponse<Models.InsuranceCodeTypeBulkResult> = await this.instance.post(`/InsuranceCodeTypes/bulk`, items);
    return data;
  };

  // Reports
  SaveReport = async (reportData: Models.Report) => {
    const { data }: AxiosResponse<Models.ReportDto> = await this.instance.post(`/Reports/Save`, reportData);
    return data;
  };
  GetAllReports = async () => {
    const { data }: AxiosResponse<Models.ReportData[]> = await this.instance.get(`/Reports`);
    return data;
  };
  GetAllReportsArchives = async () => {
    const { data }: AxiosResponse<Models.ReportArchive[]> = await this.instance.get(`/Reports/reportArchives`);
    return data;
  };
  DeleteReportArchive = async (id: number) => {
    const { data }: AxiosResponse<Models.ReportArchive> = await this.instance.delete(`/Reports/reportArchives/${id}`);
    return data;
  };
  DeleteReport = async (id: number) => {
    const { data }: AxiosResponse<Models.Report> = await this.instance.delete(`/Reports/${id}`);
    return data;
  };
  DownloadReports = async (moduleId: number, selectedReportIds: number[]) => {
    const { data }: AxiosResponse<string> = await this.instance.post(`/Reports/Download/ReportsData/${moduleId}`, selectedReportIds);
    return data;
  };
  DownloadInsuranceReports = async (moduleId: number, selectedReportIds: number[]) => {
    const { data }: AxiosResponse<Blob> = await this.instance.post(`/Reports/Download/ReportsData/${moduleId}`, selectedReportIds, {
      responseType: "blob",
    });
    return data;
  };
  DownloadInterModuleReports = async (selectedReportIds: number[]) => {
    const { data }: AxiosResponse<string> = await this.instance.post(`/Reports/Download/InterModuleReportsData`, selectedReportIds);
    return data;
  };
  DownloadModuleAssumptions = async (id: number) => {
    const { data }: AxiosResponse<string> = await this.instance.post(`/Reports/Assumptions/Download/${id}`);
    return data;
  };
  GetInsuranceReportAssumptions = async (id: number) => {
    const { data }: AxiosResponse<{ codeType: string; percentage: string }[]> = await this.instance.get(`/Reports/${id}/assumptions`);
    return data;
  };
}
